import * as React from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Get } from '../services/http';
import './dialog.css';

export default function ArticlePopup() {
    const [article, setArticle] = React.useState();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('s'));
    const isOpen = useStoreState((state) => state.articlePopup.isOpen);
    const articleName = useStoreState((state) => state.articlePopup.articleName);
    const buttonName = useStoreState((state) => state.btnName);
    const isCallBack = useStoreState((state) => state.isCallBack);
    const close = useStoreActions((actions) => actions.closeArticle);
    const callback = useStoreState((state) => state.callback);

    const getArticle = async (articleId) => {
        const serverData = await Get('/api/auth/getArticleContent', { id: articleId });
        if (serverData.result) {
            setArticle(serverData.article);
        }
        console.log('articles', serverData);
    };

    const handleClose = () => {
        close();
        if (isCallBack) callback();
    };

    const getArticleId = (name) => {
        switch (name) {
            case ('terms'):
                return 10007;
            default:
                return 0;
        }
    };

    React.useEffect(() => {
        console.log('articleName', articleName);
        if (articleName !== null) {
            getArticle(getArticleId(articleName));
        }
    }, [articleName]);

    return (
        <div>
            <Dialog
                className="glass-dialog-container glass-dialog-container-two login-third"
                open={isOpen}
                onClose={handleClose}
                fullScreen={fullScreen}
            >
                <DialogContent>
                    <div>
                        <Button
                            variant="outlined"
                            color="success"
                            fullWidth
                            onClick={handleClose}
                        >
                            {buttonName}
                        </Button>
                        <div className="page-title">
                            {article?.name}
                        </div>
                        <div className="article-main-image">
                            <img src={article?.mainImage} alt={article?.name} />
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: article?.content }} />
                        <Button
                            variant="outlined"
                            color="success"
                            fullWidth
                            onClick={handleClose}
                        >
                            {buttonName}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
